import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { blogs } from "../components/assets/data/dummydata";
import Testimonials from "./Testimonials";

export const Blog = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);

      if (element) {
        const headerOffset = 100;
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  }, [location]);

  const handleTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <section id="courses" className="py-16 bg-gray-50">
        <div className="w-4/5 m-auto">
          {/* Header */}
          <div className="text-center mb-14">
            <h1 className="text-4xl font-bold text-[#B71C1C] leading-snug">
              Visita e Interactúa con CevaBlog
            </h1>

            <div className="w-24 h-1 bg-[#D4A017] mx-auto my-4 rounded-full"></div>

            <h2 className="text-xl font-semibold text-[#0B3D91]">
              Somos más que un instituto, somos una familia
            </h2>

            <p className="text-gray-600 max-w-4xl mx-auto mt-5 leading-relaxed">
              Mantente informado con <strong>Cevatips</strong> y{" "}
              <strong>Cevafest</strong>, espacios creados para compartir
              experiencias, consejos prácticos y novedades institucionales.
              Descubre contenido útil y dinámico diseñado para acompañarte en
              cada etapa de tu crecimiento académico y profesional.
            </p>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-3 gap-8 md:grid-cols-1">
            {blogs.slice(0, 3).map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition duration-300"
              >
                {/* FOTO CLICKEABLE */}
                <NavLink to={item.url} onClick={handleTop}>
                  <div className="relative overflow-hidden h-52 w-full cursor-pointer">
                    <img
                      src={item.cover}
                      alt={item.title}
                      className="w-full h-full object-cover transition duration-500 hover:scale-110"
                    />
                  </div>
                </NavLink>

                {/* Content */}
                <div className="p-5">
                  <span className="text-xs bg-[#0B3D91] text-white px-3 py-1 rounded-md font-medium">
                    Lifestyle
                  </span>

                  <NavLink to={item.url} onClick={handleTop}>
                    <h3 className="text-lg font-semibold text-gray-800 mt-4 hover:text-[#B71C1C] transition cursor-pointer min-h-[56px]">
                      {item.title}
                    </h3>
                  </NavLink>

                  <p className="text-sm text-gray-600 mt-3 leading-relaxed">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pt-10 pb-16">
        <Testimonials />
      </section>
    </>
  );
};